<template lang="html">
  <div class="modal-wrapper" style="overflow: visible;">
    <div class="modal-close">
      <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
    </div>
    <div class="modal-title">
      Izmena kategorije
    </div>
    <div class="inputs">
      <div v-for="category in categoryData" :key="category.cat_id + category.cat_locale" class="single-input">
        <span>Ime kategorije {{category.cat_locale}}</span>
        <input v-model="category.cat_name" type="text" name="">
      </div>
    </div>
    <div class="btn-wrapper">
      <div @click="edit" class="btn">
        ok
      </div>
      <div @click="closeModal" class="btn">
        cancel
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
import { api } from '@/api'
export default {
  name: 'adminEditCategory',
  data () {
    return {
      categoryData: []
    }
  },
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  mounted() {
    for (var i = 0; i < this.$i18n.availableLocales.length; i++) {
      let obj = {
        cat_locale: this.$i18n.availableLocales[i],
        cat_name: ''
      }
      this.categoryData.push(obj)
    }
    let params = {
      cat_id: this.modalData.cat_id
    }
    api.getCategoryId(params).then(res => {
      for (var i = 0; i < this.categoryData.length; i++) {
        for (var j = 0; j < res.data.data.length; j++) {
          if (this.categoryData[i].cat_locale === res.data.data[j].cat_locale) {
            this.categoryData[i].cat_name = res.data.data[j].cat_name
          }
        }
      }
    }).catch(e => {
      this.$toast.error('Greška', {
        duration: 8000
      })
    })
  },
  methods: {
    closeModal () {
      eventBus.$emit('closeModal')
    },
    edit () {
      let params = {
        names: this.categoryData,
        id: this.modalData.cat_id
      }
      api.adminEditCategory(params).then(res => {
        this.$toast.success('Uspešno', {
          duration: 8000
        })
        this.closeModal()
      }).catch(e => {
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
